export const BRANCH_STORE_TTL_ES = 'SUCURSALES';
export interface IBranchStoreBase {
  name: string;
  address: string;
  provinceId: number;
  departmentId: number;
  districtId: number;
  establishmentCode: string;
}

export interface IBranchStore extends IBranchStoreBase {
  id: number;
}

export interface IBranchStoreTable extends IBranchStore {
  department: string;
  province: string;
  district: string;
}
export type IBranchStoreUpdate = Partial<IBranchStoreBase>;

export interface IDepartament {
  id: number;
  name: string;
}

export interface IProvince {
  id: number;
  name: string;
}

export interface IDistrict {
  id: number;
  name: string;
}
